var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.switchLocale}},[_c('v-icon',[_vm._v("mdi-earth")]),_vm._v(" "+_vm._s(_vm.$i18n.locale)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }